import { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import { AppStateProvider } from "./context";

import containers from "./context/state";
import Routing from "./routing";

import { chooseTheme, themes } from "./components";

import "./App.scss";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingScreen from "./components/common/LoadingScreen";

function App() {
  const _theme = themes[chooseTheme()];

  return (
    <AppStateProvider containers={containers}>
      <BrowserRouter>
        <Suspense fallback={<LoadingScreen />}>
          <ThemeProvider theme={_theme}>
            <Routing />
            <div>
              <Toaster
                position="top-right"
                containerStyle={{
                  // top: "40%",
                  left: "30%",
                }}
                toastOptions={{
                  style: {
                    // minHeight: "120px",
                    // padding: "20px",
                    // fontSize: "20px",
                    // display: "flex",
                    // flexDirection: "row",
                    // alignItems: "center",
                    // justifyContent: "center",
                    // gap: "10px",
                    // textAlign: "center",
                  },
                }}
              />
            </div>
          </ThemeProvider>
        </Suspense>
      </BrowserRouter>
    </AppStateProvider>
  );
}

export default App;
